import { APP_LINKS } from '../config/app-links.config';

export const getOS = () => {
  const userAgent = window.navigator.userAgent || window.navigator.vendor || (window as any).opera;
  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return 'iOS';
  }
  return 'unknown';
};

export const handleAppDownloadRedirect = () => {
  const os = getOS();
  const iosLink =
    APP_LINKS.ios && APP_LINKS.ios !== '#' ? APP_LINKS.ios : 'https://apps.apple.com/';

  if (os === 'iOS') {
    window.location.href = iosLink;
  } else {
    window.open(iosLink, '_blank');
  }
};
